module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-community-organized.svg?655dd12f29d4bf11b0b24af5e0a6831d";